// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__smC39","header":"ReportDetails_header__3gcEr","title":"ReportDetails_title__15gnm","left":"ReportDetails_left__1srv8"};